const HOMEMARKETS = {
    chile: {
      title: "Chile",
      slug: "cl",
      languageTitle: "es",
      parsedName: "chile",
      currency: "CLP",
      secondarySlug: "CL",
    },
    peru: {
      title: "Perú",
      slug: "pe",
      languageTitle: "es",
      parsedName: "peru",
      currency: "USD",
      secondarySlug: "PE",
    },
    otros: {
      title: "Otros (Español)",
      slug: "others",
      languageTitle: "Otros",
      parsedName: "otros",
      currency: "USD",
      secondarySlug: "ES",
    },
    english: {
      title: "Estados Unidos",
      slug: "english",
      languageTitle: "en-US",
      parsedName: "english",
      currency: "USD",
      secondarySlug: "EN",
    },
  };
  
  export default HOMEMARKETS;